import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import config from '../config';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const role = localStorage.getItem('verichain_role') || 'operator';

  const handleLogout = () => {
    localStorage.removeItem('verichain_user');
    localStorage.removeItem('verichain_role');
    navigate('/login');
  };

  const navItem = (label, path) => (
    <button
      onClick={() => navigate(path)}
      style={{
        background: 'none',
        border: 'none',
        color: location.pathname === path ? '#C9920A' : '#CBD5E1',
        cursor: 'pointer',
        fontSize: '13px',
        fontWeight: location.pathname === path ? 'bold' : 'normal',
        padding: '8px 16px',
        borderBottom: location.pathname === path ? '2px solid #C9920A' : '2px solid transparent',
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{
      backgroundColor: '#0F2040',
      borderBottom: '1px solid #1E3A6E',
      padding: '0 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '56px',
      position: 'sticky',
      top: 0,
      zIndex: 100,
    }}>

      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#FFFFFF',
          letterSpacing: '2px',
        }}>
          {config.APP_NAME.toUpperCase()}
        </span>
        <span style={{
          fontSize: '9px',
          color: '#C9920A',
          fontStyle: 'italic',
          letterSpacing: '1px',
        }}>
          by VERICHAIN
        </span>
      </div>

      {/* Nav Items — role based */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {navItem('Dashboard', '/dashboard')}
        {navItem('View Batches', '/batches')}
        {navItem('Intelligence', '/intelligence')}

        {/* Operator only */}
        {role === 'operator' && navItem('Register Batch', '/register-batch')}
        {role === 'operator' && navItem('Recall', '/recall')}

        {/* Manager only */}
        {role === 'manager' && (
          <button
            onClick={() => navigate('/approvals')}
            style={{
              background: 'none',
              border: location.pathname === '/approvals' ? '1px solid #C9920A' : '1px solid #F0B429',
              color: location.pathname === '/approvals' ? '#C9920A' : '#F0B429',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 'bold',
              padding: '6px 16px',
              borderRadius: '4px',
              marginLeft: '8px',
            }}
          >
            ⚡ Approvals
          </button>
        )}
      </div>

      {/* Right side */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span style={{
          fontSize: '11px',
          color: role === 'manager' ? '#F0B429' : '#64748B',
          textTransform: 'uppercase',
          letterSpacing: '1px',
        }}>
          {role}
        </span>
        <button
          onClick={handleLogout}
          style={{
            background: 'none',
            border: '1px solid #C0392B',
            color: '#C0392B',
            cursor: 'pointer',
            fontSize: '12px',
            padding: '6px 14px',
            borderRadius: '4px',
          }}
        >
          Sign Out
        </button>
      </div>

    </div>
  );
}

export default Navbar;